




























































import Vue from "vue";
import Component from "vue-class-component";
import { BFormInput, BFormFile, BButton, BSpinner, BTableSimple, BThead, BTbody, BTr, BTh, BTd } from "bootstrap-vue";
import { RootActionTypes } from "@/store";
import { RootState } from "@/store";
import AppHeading from "@/components/AppHeading.vue";
import { mapState, mapGetters } from "vuex";
import { adminGuard } from "@/router/guards";
import { namespaceAuth, AuthActionTypes } from "../../store/auth";

@Component({
  name: "UsersPage",
  beforeRouteEnter: adminGuard,
  components: { AppHeading, BButton, BFormInput, BTableSimple, BThead, BTbody, BTr, BTh, BTd },
  computed: {
    ...mapState<RootState>({
      users: (state: RootState) => state.users
    }),
    name: {
      get() {
        return this.$store.state.userSearch;
      },
      set(value) {
        this.$store.dispatch(`${RootActionTypes.FetchUser}`, value);
      }
    }
  },
  mounted() {
    this.$store.dispatch(`${RootActionTypes.FetchUser}`);
  }
})
export default class ProfilePage extends Vue {
  isLoading: boolean;

  loginAs = async (event: any, userId: number) => {
    this.isLoading = true;
    await this.$store.dispatch(`${namespaceAuth}/${AuthActionTypes.LoginWithUserId}`, userId);
    this.isLoading = false;
  };
}
